export const defaultColumns = [
  {label: 'Nome do cargo', value: 'display_name'}, 
  {label: 'Ult. Atualização', value: 'updatedAt', className: 'w-[200px]'},
  {label: 'Ações', value: 'actions', className: 'w-9'},
]